import {
  PropertyStatus,
  StyledAddressContainer,
  StyledCard,
  StyledLinkElement,
  StyledPhotoAddressContainer,
  StyledPropertyCardCTAContainer,
  StyledPropertyPanel,
  StyledPropertyPanelContainer,
} from './StyledComponents';

const PropertyCardSkeleton = () => (
  <StyledCard>
    <StyledPhotoAddressContainer dark={true}>
      <PropertyStatus />
    </StyledPhotoAddressContainer>

    <StyledPropertyCardCTAContainer>
      <StyledAddressContainer dark={true} />
      <StyledLinkElement dark={true} />
    </StyledPropertyCardCTAContainer>

    <StyledPropertyPanelContainer>
      <StyledPropertyPanel dark={true} />
      <StyledPropertyPanel dark={true} />
      <StyledPropertyPanel dark={true} />
    </StyledPropertyPanelContainer>
  </StyledCard>
);

export default PropertyCardSkeleton;
